import instance from '../private/instance';

const Logout = async () => instance.post('/users/logout/');

export default Logout;
